<template>
  <Layout>
    <GoBack class="mb-5" text="shottracker articles" link="ArticlesPage" />
    <Title class="my-4" text="Edit Article" />
    <LoadingSpinner v-if="loading.display" :message="loading.message" />
    <ArticleForm
      v-else
      :form="file.JSON"
      @handleSubmit="handleSubmit"
      :imageUploaded="file.imageURL"
      :editMode="true"
    />
  </Layout>
</template>

<script>
import Title from "../Title.vue";
import Layout from "../../Layout.vue";
import GoBack from "../../GoBack.vue";
import LoadingSpinner from "../../LoadingSpinner.vue";
import ArticleForm from "./ArticleForm.vue";
import { mapGetters, mapActions } from "vuex";
import loader from "../../../mixins/loader";
import initData from "../../../mixins/initData";

export default {
  name: "EditArticle",
  mixins: [loader, initData],

  components: {
    Layout,
    GoBack,
    LoadingSpinner,
    ArticleForm,
    Title,
  },

  data() {
    return {
      header: "",
      subheader: "",
      author: "",
      homeFeatured: false,
    };
  },

  computed: {
    ...mapGetters(["directory", "articlesID", "file"]),

    noArticles() {
      return this.directory.articles === 0;
    },
  },

  methods: {
    ...mapActions(["fetchFile", "updateFileInS3", "updateArticleInS3"]),

    async handleSubmit() {
      const newHeader = this.file.JSON.header;
      const newAuthor = this.file.JSON.author;
      const newSubheader = this.file.JSON.subheader;
      const newHomeFeatured = this.file.JSON.homeFeatured;

      const updateDirectory =
        this.header !== newHeader ||
        this.author !== newAuthor ||
        this.subheader !== newSubheader ||
        this.homeFeatured !== newHomeFeatured;

      let updatedIndex = null;

      if (updateDirectory) {
        updatedIndex = {
          header: newHeader,
          author: newAuthor,
          homeFeatured: newHomeFeatured,
          subheader: newSubheader,
          id: this.file.identifier,
        };
      }

      const file = this.file;
      const { directoryKey } = this.articlesID;
      const newFile = { file, updatedIndex, directoryKey };
      await this.load(this.updateArticleInS3(newFile), "Updating article");

      this.$router.push({
        name: "ArticlesPage",
        params: { id: this.file.identifier },
      });
    },
  },

  async created() {
    const identifier = this.$route.params.id;

    if (this.noArticles) {
      await this.load(this.initData(this.articlesID), "Loading article");
    }

    await this.load(this.fetchFile(identifier), "Loading article");

    this.header = this.file.JSON.header;
    this.author = this.file.JSON.author;
    this.subheader = this.file.JSON.subheader;
    this.homeFeatured = this.file.JSON.homeFeatured;
  },
};
</script>

